export default class BusinessEvidenceFileEntity {

    constructor() {

        this.categoryShow = false
        this.categoryRequired = false
        this.categoryLabel = 'Categoria'
        this.categoryOrder = 1

        this.serviceShow = false
        this.serviceRequired = false
        this.serviceLabel = 'Serviço'
        this.serviceOrder = 2

        this.statusShow = false
        this.statusRequired = false
        this.statusLabel = 'Status'
        this.statusOrder = 3

        this.complementShow = false
        this.complementRequired = false
        this.complementLabel = 'Detalhe do Ambiente'
        this.complementOrder = 4

    }

}